import graphql from './graphql';

const query = /* GraphQL */ `
  query DocumentCourse_list($courseId: ID!) {
    DocumentCourse_list(courseId: $courseId) {
      id
      courseId
      name
      size
      url
      updatedAt
    }
  }
`;

const DocumentCourseList = async ({ courseId }) =>
  graphql(query, { courseId }).then(
    // eslint-disable-next-line camelcase
    ({ DocumentCourse_list }) => DocumentCourse_list
  );

export default DocumentCourseList;
